module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-8e1ed89b.woff2";